import React, { useState, useEffect } from 'react';
import Link from '@mui/material/Link';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import Container from '@mui/material/Container';

import Button from '@mui/material/Button';
import MailOutline from '@mui/icons-material/MailOutline';
import Copyright from '../../components/Copyright';
import { useNotification } from '../../context/NotificationContext';
import {
  WEBSITE_NAME,
  SUPPORT_EMAIL,
  WEBSITE_LINK,
  PRODUCT_NAME,
} from '../../common/AppConstants';

function preventDefault(event) {
  event.preventDefault();
}

const termsList = [
  {
    title: 'Product & Service Delivery',
    content:
      'Access to services and features is granted immediately once your payment has been successfully processed.',
    children: [
      {
        content:
          'You will receive access to features according to your subscribed plan.',
        listItems: [
          'Delivery of our digital services will be confirmed via email sent to the registered email address provided during account creation.',
          'In case you do not receive confirmation within a reasonable time after successful payment, please contact us at {SUPPORT_EMAIL}.',
          'Your plan details, validity period, and access level can be viewed anytime within your account dashboard.',
        ],
      },
    ],
  },
  {
    title: 'Changes to This Shipping Policy',
    content:
      'We reserve the right to update this Shipping Policy at any time. Users are responsible for reviewing them regularly. Continued use of the service after changes means you accept them.',
    children: [
      {
        content:
          'We will notify users of significant changes via email or website notifications.',
        listItems: [],
      },
    ],
  },
  {
    title: 'Contact Us',
    content:
      'For any questions or concerns regarding this Shipping Policy, please contact us at {SUPPORT_EMAIL}.',
    children: [
      {
        content: 'If you are unable to access any feature that you believe is included in your plan, please contact us at {SUPPORT_EMAIL} for assistance.',
        listItems: [],
      },
    ],
  },
];

const replacePlaceholders = (text) => {
  if (!text) return text; // Handle empty strings gracefully
  return text
    .replaceAll('{SUPPORT_EMAIL}', SUPPORT_EMAIL)
    .replaceAll('{WEBSITE_LINK}', WEBSITE_LINK)
    .replaceAll('{WEBSITE_NAME}', WEBSITE_NAME)
    .replaceAll('{PRODUCT_NAME}', PRODUCT_NAME);
};

export default function PrivacyPolicy() {
  const { addNotification } = useNotification();

  return (
    <Container component="main" maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h3" gutterBottom sx={{ textAlign: 'center', mb: 2 }}>
        Shipping & Delivery Policy
      </Typography>
      <Typography variant="body1" paragraph sx={{ textAlign: 'center', mb: 5 }}>
        {PRODUCT_NAME} [{WEBSITE_NAME}] is a 100% digital platform - all products and services are accessed online.
        There are no physical products, shipping, or delivery involved.
      </Typography>

      {termsList.map((section, section_index) => (
        <Box key={section_index}>
          <Typography variant="h5" sx={{ mt: 3 }}>
            {section_index + 1}
            {'. '}
            {replacePlaceholders(section.title)}
          </Typography>
          <Typography variant="body1">
            {replacePlaceholders(section.content)}
          </Typography>

          {section.children.map((children, children_index) => (
            <Box key={section_index}>
              <Typography variant="body1" sx={{ pt: 1, pb: 0, pl: 0, pr: 0 }}>
                {replacePlaceholders(children.content)}
              </Typography>
              <List disablePadding>
                {children.listItems.map((item, item_index) => (
                  <ListItem disablePadding key={item_index} sx={{ pl: 0 }}>
                    <ListItemText
                      primary={
                        <Typography variant="body1">
                          {'* '}
                          {replacePlaceholders(item)}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          ))}
        </Box>
      ))}

      <Typography variant="h5" sx={{ mt: 3 }}>
        Last Updated: 24th October, 2025
      </Typography>
      <Copyright sx={{ mt: 5 }} />
    </Container>
  );
}
